import { CurrencyPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ErrorMessage, Regex } from '@lsq-frontend/common-ui';

@Injectable()
export class CreditLimitMinValidator {
    constructor(public currencyPipe: CurrencyPipe) {}

    public validator(min: number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (control.value !== '' && isNaN(control.value)) {
                return {
                    number: { message: ErrorMessage.number }
                };
            }

            if (control.value !== '' && !Regex.Currency.test(control.value)) {
                return {
                    currency: { message: ErrorMessage.currency }
                };
            }

            if (control.value <= min) {
                return {
                    creditLimitMin: {
                        message: `Please enter an amount greater than your current credit limit of ${this.currencyPipe.transform(
                            min
                        )}`
                    }
                };
            }

            return null;
        };
    }
}
